import React, { useEffect, useState, useRef, useMemo } from 'react';
import './CaseFirstCard.css'; // CSS file for styles
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import { ClipLoader } from 'react-spinners';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import SuccessIcon from './SuccessIcon';
import { useNavigate } from 'react-router-dom';
import axios from "../../../../axiosInstance.js";
// import Modal from '../Location1/Modal';
import Modal from '../../../CompanyAdmin/Location1/Modal';
import crossUser from '../../../../Assets/crossUser.png'
import FirstCardPage from './FIrstCardPage';
import { gsap } from "gsap";
import { ChevronDown, ChevronUp } from 'lucide-react';

function haversineDistance(lat1, lon1, lat2, lon2) {
    const toRadians = angle => (Math.PI / 180) * angle;
    lat1 = toRadians(lat1);
    lon1 = toRadians(lon1);
    lat2 = toRadians(lat2);
    lon2 = toRadians(lon2);

    const dlat = lat2 - lat1;
    const dlon = lon2 - lon1;
    const a = Math.sin(dlat / 2) ** 2 +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(dlon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const radiusOfEarthKm = 6371;
    const distance = radiusOfEarthKm * c;

    return distance;
}



const CaseFirstCard = ({ data, pendingCasesLength, getBackPage }) => {
    const [isRejected, setIsRejected] = useState(false)
    const [isAccepted, setIsAccepted] = useState(false)

    const [selectedIndex, setSelectedIndex] = useState(0); // default to 0
    const [editableDriverIndex, setEditableDriverIndex] = useState(null);
    const [selectedVendorVehicle, setSelectedVendorVehicle] = useState('');
    const [selectedVendorDriver, setSelectedVendorDriver] = useState(null);

     // New state for horizontal scroll
    const [selectedCardCode, setSelectedCardCode] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const scrollRef = useRef(null);

    const [acceptedRequest, setAcceptedRequest] = useState(false)
    const [isBudget, setIsBudget] = useState(false)
    const [isSlidDown, setIsSlidDown] = useState(false)
    const [getVendorData, setGetVendorData] = useState([])
    const [accidentDataById, setAccidentDataById] = useState([])
    const [rate, setRate] = useState(null)
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [charges, setCharges] = useState('');
    const [otherReason, setOtherReason] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [completeSuccessfully, setCompleteSuccessfully] = useState(false);
    const [vendorDecision, setVendorDecision] = useState("");
    const [stopClockTimer, setStopClockTimer] = useState(null);

    const [responseVehicle, setResponseVehicle] = useState(null);
    const [isViewImage, setIsViewImage] = useState(false);
    const [alreadyDoneNotification, setAlreadyDoneNotification] = useState(false);
    const [incomingMessage, setIncomingMessage] = useState('');
    const [vendorDecisions, setVendorDecisions] = useState({});
    const [acceptedStatus, setAcceptedStatus] = useState({});

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const navigate = useNavigate();

    const uniqueData = useMemo(() => {
        return Array.from(new Map(data.map(item => [item.AccidentVehicleCode, item])).values());
    }, [data]);


    useEffect(() => {
        if (userId) {
            getVendorById(userId);
        }
    }, [userId]);
    const fetchedCodesRef = useRef(new Set());
    useEffect(() => {
        if (uniqueData.length > 0) {
            uniqueData.forEach((item) => {
                const code = item?.AccidentVehicleCode;
                if (code && !fetchedCodesRef.current.has(code)) {
                    fetchedCodesRef.current.add(code); // mark as fetched
                    getAccidentDataById(code);
                }
            });
        }
    }, [uniqueData]);

    const getVendorById = async (userId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendor/${userId}/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
            //console.log("caseFirstCardhser", response.data.data)
            setGetVendorData(response.data.data);
        } catch (error) {
            console.error("Error fetching all accident vehicle data", error);
        }
    };

    const getAccidentDataById = async (AccidentVehicleCode) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVehicleAccidentById/${AccidentVehicleCode}/${userId}`);
            const newData = response.data.data;

            setAccidentDataById(prev => {
                const alreadyExists = prev.find(item => item.AccidentVehicleCode === newData[0]?.AccidentVehicleCode);
                if (alreadyExists) return prev; // skip duplicate
                return [...prev, ...newData];   // append new data
            });
        } catch (error) {
            console.error("Error fetching all accident vehicle data", error);
        }
    };


    useEffect(() => {
        if (getVendorData.length != 0)
            setRate(getVendorData[0].rate)
    }, [getVendorData])


    const reasons = [
        "Vehicle Break Down",
        "Personal Issue",
        "Long Distance",
        "Heavy Rain",
        "Strike",
    ];

    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedReasons([...selectedReasons, reason]);
        }
    };
    //console.log("reason", selectedReasons)

    const acceptOrder = () => {
        // Corrected from setIsAccpeted
        setSelectedCardCode(null);
        setIsViewImage(false)
        setIsRejected(false)
        setIsAccepted(false)
        setIsBudget(true)
    };
    const rejectOrder = () => {
        setSelectedCardCode(null);
        setIsAccepted(false)
        setIsViewImage(false)
        setIsRejected(true)
        setVendorDecision('reject')
    }
    const viewImageHere = () => {
        setIsBudget(false)
        setSelectedCardCode(null);
        setIsAccepted(false)
        setIsRejected(false)
        setIsViewImage(true)

    }
    const closeViewImages = () => {
        setIsBudget(false)
        setIsAccepted(false)
        setIsViewImage(false)
        setIsRejected(false)
        setSelectedCardCode(null);

    }
    const closeViewBudget = () => {
        setIsAccepted(false)
        setIsViewImage(false)
        setIsRejected(false)
        setIsBudget(false)
        setSelectedCardCode(null);

    }
    const finallyAccepted = () => {
        setIsBudget(false)
        setIsAccepted(true)
        setVendorDecision('accept');
    }

    useEffect(() => {
        if (vendorDecision === 'accept') {  // Corrected from isAccpeted
            //console.log('setResponseVehicle', responseVehicle)
            handleSubmit();
        }
    }, [isAccepted, vendorDecision]);

    useEffect(() => {
        if (stopClockTimer === true) {
            //console.log('stopClocltimer') // Corrected from isAccpeted
            handleSubmit();
        }
    }, [stopClockTimer]);

    const closeRejected = () => {
        setIsRejected(false)
        setIsAccepted(false)
        setSelectedCardCode(null)

    }


    const [photoPreviews, setPhotoPreviews] = useState({
        MajorDamages1: null,
        MajorDamages2: null,
        MajorDamages3: null,
        MajorDamages4: null,
        MajorDamages5: null,
    });

    const [photos, setPhotos] = useState({
        MajorDamages1: null,
        MajorDamages2: null,
        MajorDamages3: null,
        MajorDamages4: null,
        MajorDamages5: null,
    });

    useEffect(() => {
        if (accidentDataById && accidentDataById[0]) {
            setPhotoPreviews({
                MajorDamages1: accidentDataById[0].MajorDamages1 || null,
                MajorDamages2: accidentDataById[0].MajorDamages2 || null,
                MajorDamages3: accidentDataById[0].MajorDamages3 || null,
                MajorDamages4: accidentDataById[0].MajorDamages4 || null,
                MajorDamages5: accidentDataById[0].MajorDamages5 || null,
            });

            //console.log("photoPreviews", photoPreviews.MajorDamages1)
            setPhotos({
                MajorDamages1: accidentDataById[0].MajorDamages1 || null,
                MajorDamages2: accidentDataById[0].MajorDamages2 || null,
                MajorDamages3: accidentDataById[0].MajorDamages3 || null,
                MajorDamages4: accidentDataById[0].MajorDamages4 || null,
                MajorDamages5: accidentDataById[0].MajorDamages5 || null,
            });
        }
    }, [accidentDataById]);

    const [expandedImage, setExpandedImage] = useState(null);

    const photoRefs = {

        MajorDamages1: useRef(null),
        MajorDamages2: useRef(null),
        MajorDamages3: useRef(null),
        MajorDamages4: useRef(null),
        MajorDamages5: useRef(null)
    };



    //console.log("isAccepteod", isAccepted)
    const handleSubmit = async (overrideDecision = null, overrideReasons = null) => {
        try {
            let finalDecision = overrideDecision ?? vendorDecision;
            let finalSelectedReasons = overrideReasons ?? selectedReasons;

            // Handle timeout case if nothing selected
            if (!finalDecision && finalSelectedReasons.length === 0) {
                finalDecision = 'reject';
                finalSelectedReasons = ['time-out'];
            }

            //console.log('vendordesc', finalDecision, finalSelectedReasons);

            // Validate rejection reasons
            if (finalDecision === 'reject' && finalSelectedReasons.length === 0 && otherReason.trim() === "") {
                setErrorMessage("Please select at least one reason or provide another reason.");
                return;
            }

            setErrorMessage("");
            setIsLoading(true);

            const updatedReasons = finalDecision === 'reject'
                ? [...finalSelectedReasons, otherReason].filter(r => r && r.trim() !== '')
                : finalSelectedReasons;

            const formData = {
                vendorDecision: finalDecision,
                rejectionReason: updatedReasons,
            };

            //console.log("FormData1234", formData);

            const formDataObj = new FormData();
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
                    if (formData[key] instanceof File) {
                        formDataObj.append(key, formData[key], formData[key].name);
                    } else {
                        formDataObj.append(key, formData[key]);
                    }
                }
            }

            const response = await axios({
                method: 'POST',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/vendorOnAssignedVehicle/${selectedVendorVehicle}/${selectedVendorDriver[0]}/${responseVehicle}/${userId}/admin`,
                data: formDataObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            setResponseVehicle(null);
            if (response.data.message === "Another Vendor Already Accepted Case" || response.data.message === "Your Request Added Successfully !!!." || response.data.message === "Order Gets Cancelled") {
                setAlreadyDoneNotification(true);
                const message = response.data.message === "Your Request Added Successfully !!!."
                    ? response.data.message
                    : `but ${response.data.message}`;

                setIncomingMessage(message);
                setIsRejected(false);
                setSelectedCardCode(null);
                setIsAccepted(false);
                setAcceptedRequest(false)

                setTimeout(() => {
                    getBackPage(false);  // Pass true to parent
                }, 10000);
            }

            if (response.data.message === "Your Request Added Successfully As Accepted !!!.") {
                setIsRejected(false);
                setSelectedCardCode(null);
                setIsAccepted(false);
                setAcceptedRequest(true)

                setTimeout(() => {
                    getBackPage(true, data[0].AccidentVehicleCode);
                }, 1000);
            }

        } catch (error) {
            setIsLoading(false);
            console.error("Error submitting form:", error.response ? error.response.data : error.message);
        }
    };

    const handleFormattedTime = (formattedTime) => {
        //console.log("Formatted Time from Child:", formattedTime);
        setTimeLeft(formattedTime)
    };

    const [timeLeft, setTimeLeft] = useState(0);

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };
    const [assignedOn, setAssignedOn] = useState(localStorage.getItem('assignedOn'));


    useEffect(() => {

        if (!assignedOn) return;
        const caseAssignedAt = new Date(assignedOn).getTime();
        const now = new Date().getTime();
        const timeElapsed = Math.floor((now - caseAssignedAt) / 1000); // in seconds
        const totalDuration = 9000; // 30 seconds countdown
        const initialTimeLeft = totalDuration - timeElapsed;
        setTimeLeft(initialTimeLeft > 0 ? initialTimeLeft : 0);

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    setStopClockTimer(true)
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(timer); // Cleanup the interval on component unmount
    }, [assignedOn]);

    const handleChildData = (data) => {
        //console.log('================================')
        //console.log(data)
        setAssignedOn(data);
    };

    const handleScroll = () => {
        if (!scrollRef.current) return;
        const scrollX = scrollRef.current.scrollLeft;
        const itemWidth = scrollRef.current.firstChild?.offsetWidth || 1;
        const newIndex = Math.round(scrollX / itemWidth);
        setActiveIndex(newIndex);
    };
    const handleCardClick = (code) => {
        setSelectedCardCode(code);
    };

    return (
        <div>

            {alreadyDoneNotification && (
                <div
                    className="fixed top-10 left-4 z-[1001] w-auto max-w-md bg-white text-gray-800 rounded-2xl shadow-2xl border border-gray-200 animate-fadeIn font-satoshi pt-2 px-4 pb-3"
                >
                    <button
                        onClick={() => setAlreadyDoneNotification(false)}
                        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
                    >
                        <CloseIcon />
                    </button>

                    <div className="flex flex-col gap-2 pr-6">
                        <h2 className="text-lg font-semibold text-red-600">Notification</h2>
                        <p className="text-sm text-gray-600">
                            <strong>{incomingMessage}</strong>
                        </p>
                    </div>
                </div>


            )}

            {/* Horizontal Scrollable Notification Cards */}

           {!selectedCardCode && accidentDataById.length !== 0 && getVendorData.length !== 0 && (
    <div className='fixed bottom-[3rem] w-full bg-transparent flex flex-col items-center py-2 text-xs z-50 px-3'>

        {/* Count header so the vendor immediately sees how many requests are pending */}
        <div className="w-full max-w-[90vw] mb-1 px-1">
            <span className="text-[11px] font-semibold text-white bg-[#0389be] px-2 py-1 rounded-full">
                {uniqueData.length} {uniqueData.length === 1 ? 'Request' : 'Requests'} Pending
            </span>
        </div>

        <div
            ref={scrollRef}
            onScroll={handleScroll}
            className="flex flex-col gap-2 overflow-y-auto scroll-smooth no-scrollbar w-full max-w-[90vw] max-h-[45vh]"
            style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
            }}
        >
            {uniqueData.map((item, index) => {
                const code = item.AccidentVehicleCode;

                const accidentData = accidentDataById.find(acc => acc.AccidentVehicleCode === code);
                const reg = accidentData?.reg || "Loading...";

                return (
                    <div
                        key={code}
                        onClick={() => handleCardClick(code)}
                        style={{ boxShadow: '4px 3px 12px 0px' }}
                        className="w-full flex-shrink-0 border-2 border-blue-400 bg-white rounded-[12px] px-2 py-2 cursor-pointer"
                    >
                        <div className="flex justify-around items-center">
                            <img
                                src={
                                item?.details?.[0]?.images?.["Front Right"] || "Not Available"
                                }
                                alt='vehicle'
                                className='rounded-full h-[2rem] w-[2rem]'
                            />
                            <div className="text-[0.70rem] font-bold">{reg}</div>
                            <div className="flex justify-center items-center" style={{ height: 30, width: 100 }}>
                                <div className="relative w-full h-5 rounded-full bg-[#ff0b0b38]/20 overflow-hidden">
                                    <div
                                        className="absolute top-0 left-0 h-full rounded-full bg-[#0389be] transition-all duration-300"
                                        style={{
                                            width: `${(timeLeft / 9000) * 100}%`,
                                        }}
                                    ></div>
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <span className="text-[10px] font-semibold text-red-500 animate-pulse">
                                            {formatTime(timeLeft)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    </div>
)}

             {/* Full Card Detail View */}
            {selectedCardCode && accidentDataById.length !== 0 && getVendorData.length !== 0 && (
                <div
                    className="fixed left-1/2 transform -translate-x-1/2"
                    style={{
                        bottom: 0,
                        minWidth: "90vw",
                        backgroundColor: "white",
                        borderRadius: "12px 12px 0 0",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                        zIndex: 1002,
                        overflow: "hidden",
                        transform: "translateX(-50%)",
                        maxHeight: '80vh'
                    }}
                >
                    {uniqueData.map((item) => {
                        const code = item.AccidentVehicleCode;
                        if (code !== selectedCardCode) return null;

                        const accidentData = accidentDataById.find(acc => acc.AccidentVehicleCode === code);
                        const reg = accidentData?.reg || "Loading...";
                        const images = item?.details?.[0]?.images || [];

                        return (
                            <div key={code}>
                                <div className="p-2 py-[1rem] pt-[1rem] flex justify-between items-center bg-white rounded-t-lg">
                                    <span className="font-satoshi text-sm font-bold font-medium">{reg}</span>
                                    <div className="font-satoshi flex items-center gap-2">
                                        <div className="flex justify-center items-center" style={{ height: 30, width: 100 }}>
                                            <div className="relative w-full h-5 rounded-full bg-[#ff0b0b38]/20 overflow-hidden">

                                                <div
                                                    className="absolute top-0 left-0 h-full rounded-full bg-[#0389be] transition-all duration-300"
                                                    style={{
                                                        width: `${(timeLeft / 9000) * 100}%`,
                                                    }}
                                                ></div>
                                                <div className="absolute inset-0 flex items-center justify-center">
                                                    <span className="text-[10px] font-semibold text-red-500 animate-pulse">
                                                        {formatTime(timeLeft)}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <button onClick={() => setSelectedCardCode(null)} className="cursor-pointer">
                                            <CloseIcon />
                                        </button>
                                    </div>
                                </div>

                                {/* <span>{isSlidDown ? <ChevronUp /> : <ChevronDown />}</span> */}

                                <div style={{ height: "calc(80vh - 56px)", overflowY: "auto" }}>
                                    <FirstCardPage
                                        // stopTimer={stopTimer}
                                        accidentData={accidentData}
                                        images={images}
                                        setFirstPage={(val) => !val && setSelectedCardCode(null)}
                                        setIsViewImage={setIsViewImage}
                                        setIsRejected={setIsRejected}
                                        isRejected={isRejected}
                                        setIsAccepted={setIsAccepted}
                                        setVendorDecision={setVendorDecision}
                                        setResponseVehicle={setResponseVehicle}
                                        selectedVendorVehicle={selectedVendorVehicle}
                                        setSelectedVendorVehicle={setSelectedVendorVehicle}
                                        setStopClockTimer={setStopClockTimer}
                                        selectedVendorDriver={selectedVendorDriver}
                                        setSelectedVendorDriver={setSelectedVendorDriver}
                                        selectedIndex={selectedIndex}
                                        setSelectedIndex={setSelectedIndex}
                                        onTimeUpdate={handleFormattedTime}
                                        editableDriverIndex={editableDriverIndex}
                                        setEditableDriverIndex={setEditableDriverIndex}
                                    />
                                </div>
                            </div>
                        );
                    })}
                                </div>
                            )}

                {/* Rejection Modal */}

            {isRejected && (
                <div>
                    {!completeSuccessfully && (
                        <div className='font-satoshi' style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                            zIndex: 1003,
                            display: "flex",
                            alignItems: "flex-end", // positions the container at the bottom
                            justifyContent: "center",
                            animation: "slideUp 0.5s ease-out",
                        }}>
                            <div className="image-container" style={{ background: "rgb(245 245 245 / 78%)" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: "15px", border: "4px solid black", borderImage: 'linear-gradient(to bottom, white 10%, black 90%) 1', borderRadius: "20px", margin: "20px 50px 0px 30px", padding: "5px", flex: 1 }}>Reason For Decline</h1>
                                    <div onClick={closeRejected}>
                                        <CloseIcon style={{ marginRight: '20px', cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <hr />

                                <div style={{ margin: "10px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                    {reasons.map((reason) => (
                                        <button
                                            key={reason}
                                            onClick={() => handleSelectReason(reason)}
                                            style={{
                                                fontSize: '14px',
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                padding: "10px",
                                                borderRadius: "20px",
                                                backgroundColor: selectedReasons.includes(reason) ? "yellow" : "white",
                                                border: "1px solid black",
                                                cursor: "pointer",
                                                boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                            }}
                                        >
                                            {reason}
                                        </button>
                                    ))}
                                </div>


                                <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                    <p style={{ textAlign: "left" }}> Other Reason  : </p>
                                    <textarea
                                        style={{ margin: "10px 10px 20px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                </label>

                                {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                <div>
                                    {isLoading && (
                                        <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                            <ClipLoader color="black" loading={isLoading} />
                                            <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                        </div>
                                    )}
                                    <p type="button"
                                        style={{
                                            fontSize: '11px',
                                            margin: "1rem",
                                            background: "#8f4325",
                                            padding: "10px",
                                            textAlign: 'center',
                                            borderRadius: '30px',
                                            fontWeight: "bold",
                                            color: "white",
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: "center",
                                            position: "relative",
                                        }}
                                        disabled={isLoading}
                                        onClick={() => { setVendorDecision('reject'); handleSubmit() }}                                    >
                                        < NotInterestedIcon style={{
                                            position: 'absolute',
                                            left: "3rem"
                                        }} />Reject Case
                                    </p>
                                </div>
                            </div>
                        </div>)}
                    {completeSuccessfully && (
                        <div className='parent-container'>
                            <div className="image-container" style={{ background: "radial-gradient(yellow, transparent)" }}>
                                <div style={{ marginTop: "40%" }}>
                                </div>
                                <SuccessIcon />
                                <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: "20px", color: "green", margin: "0px 50px 20px 30px", padding: "5px", flex: 1 }}>Submitted Reason !!!</h1>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* View Images Modal */}
            {isViewImage && (

                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                    zIndex: 1003,
                    display: "flex",
                    alignItems: "flex-end", // positions the container at the bottom
                    justifyContent: "center",
                    animation: "slideUp 0.5s ease-out",
                }}>
                    <div style={{
                        position: "relative",
                        width: "400px",
                        maxWidth: "600px",
                        backgroundColor: "#fff", // white background for the content
                        borderRadius: "15px 15px 0px 0px",
                        // marginBottom: "30px",
                        maxHeight: "80%", // limit the height for scrollability
                        overflowY: "auto", // enables vertical scrolling
                        padding: "20px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
                    }} >
                        <img
                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crossUser.png'
                            onClick={closeViewImages}
                            style={{
                                position: "fixed",
                                left: "calc(100% - 35px)",
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                                zIndex: 1001,
                                filter: "drop-shadow(0 0 5px rgba(255, 255, 255, 0.5))",
                            }}
                        />
                        {Object.keys(photos).map((type, index) => (
                            <div key={type} className="photo-input-section">
                                <label>
                                    <h6 style={{ fontSize: "11px" }}>
                                        {type.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}:
                                    </h6>

                                </label>
                                {photoPreviews[type] && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '20px' }}>
                                        <img
                                            src={photoPreviews[type]}
                                            alt={`Upload preview ${type}`}
                                            style={{ width: 100, height: 100, cursor: 'pointer' }}
                                            onClick={() => setExpandedImage(photoPreviews[type])}
                                        />

                                    </div>
                                )}
                            </div>
                        ))}

                        {/* Modal for expanded image view */}
                        <Modal
                            open={!!expandedImage}
                            onClose={() => setExpandedImage(null)}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                            <img
                                src={expandedImage}
                                alt="Expanded preview"
                                style={{ maxWidth: '90%', maxHeight: '90%' }}
                            />
                        </Modal>
                    </div>
                </div>
            )}
            {isAccepted && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                    zIndex: 1003,
                    display: "flex",
                    alignItems: "flex-end", // positions the container at the bottom
                    justifyContent: "center",
                    animation: "slideUp 0.5s ease-out",
                }}>
                    <div className="image-container" style={{ background: "radial-gradient(yellow, transparent)" }}>
                        <div style={{ marginTop: "40%" }}>
                        </div>
                        <SuccessIcon />
                        <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: "17px", color: "green", margin: "0px 50px 20px 30px", padding: "5px", flex: 1 }}>Thank You !!!</h1>


                    </div>
                </div>
            )}
            {isBudget && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent background
                    zIndex: 1003,
                    display: "flex",
                    alignItems: "flex-end", // positions the container at the bottom
                    justifyContent: "center",
                    animation: "slideUp 0.5s ease-out",

                }}>
                    <div className="image-container" style={{ background: "yellow" }}>
                        <img
                            src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crossUser.png'
                            onClick={closeViewBudget}
                            style={{
                                position: "relative",
                                left: "calc(100% - 30px)",
                                width: "25px",
                                height: "25px",
                                cursor: "pointer",
                                zIndex: 1001,
                                filter: "drop-shadow(0 0 5px rgba(255, 255, 255, 0.5))",
                                marginTop: "15px",
                            }}
                        />
                        <p style={{ fontSize: "12px", fontWeight: "bold", margin: "30px 60px 0px 10px" }}>Service Charge</p>

                        <input
                            type="text"
                            className="Registrationdetails-elem-9"
                            style={{ textAlign: 'left', margin: "30px 5px 20px 10px", width: '90%' }}
                            value={charges}
                            placeholder='Charges '
                            onChange={(e) => {
                                const newValue = e.target.value;
                                if (/^\d{0,10}$/.test(newValue)) {
                                    setCharges(newValue);
                                }
                            }}
                        // disabled={getData.isActive === "false"}
                        />
                        <p style={{
                            fontSize: '11px',
                            marginTop: "5px",
                            background: "rgb(115 255 115)",
                            padding: "10px",
                            border: '1px solid blue',
                            textAlign: 'center',
                            borderRadius: '30px',
                            fontWeight: "bold",
                            color: "black",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: "center",
                            position: "relative",
                            cursor: "pointer",
                            maxWidth: '80%',
                            left: "25px"
                        }} onClick={finallyAccepted}>
                            <KeyboardDoubleArrowRightIcon style={{
                                position: "absolute",
                                left: '10px'
                            }} />
                            Accept Case
                        </p>


                    </div>
                </div>
            )}

        </div>
    );
};

export default CaseFirstCard;